import { CreateDateColumn, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";

/**
 * BaseEntityと名付けたいが、ActiveRecordのBaseClassと混同する恐れがあるため別名をつける
 */
export abstract class CommonColumns {

  @PrimaryGeneratedColumn()
  id?: number;

  @CreateDateColumn({ name: 'created_at', type: 'timestamptz', })
  createdAt?: string;

  @UpdateDateColumn({ name: 'updated_at', type: 'timestamptz', })
  updatedAt?: string;
}
